import React from 'react';
import { Row, OuterMargin } from '../../Layouts';
import { SideButton, MiddleButton } from './style';
import { Icon } from '../Icons/Icons';

const CalendarToggler = ({ onToggleBack, onToggleForward, onToggleNow }) => {
    return (
        <Row>
            <SideButton onClick={onToggleBack}>
                <Icon.Box size={'8x14'}>
                    <Icon.CaretLeft />
                </Icon.Box>
            </SideButton>

            <OuterMargin left={'5px'} right={'5px'}>
                <MiddleButton onClick={onToggleNow}>Today</MiddleButton>
            </OuterMargin>

            <SideButton onClick={onToggleForward}>
                <div style={{ marginLeft: '-3px' }}>
                    <Icon.Box opacity={0.8} size={'13x14'}>
                        <Icon.CaretRight />
                    </Icon.Box>
                </div>
            </SideButton>
        </Row>
    );
};

export default CalendarToggler;



// WEBPACK FOOTER //
// ./src/UI/Components/CalendarToggler/index.js